import { FC } from 'react';

import {
  EmptyState,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../components/empty-state/index';

export const PerksSearchEmptyState: FC = () => {
  return (
    <EmptyState
      colorScheme={EmptyStateVariant.EMPTY}
      description={'Please try again'}
      imageVariant={EmptyStateImageVariant.BRIEFCASE}
      text={'No results match this search term'}
    />
  );
};
